<!-- Header section -->
<login-header></login-header>

<!-- Hero section -->
<div class="lp_hero gradient_bg" style="background-image: url('/assets/images/ourteam-bg.webp');">
    <div class="lp_hero_content d-grid align-items-center">
        <div class="lp_hero_text">
            <h1 class="lp_h1 text-capitalize">Sharing is caring!</h1>
            <p class="lp_p">You love Family Central so share it with the people you care about.
                Family Central subscribers can share custom invitations with those they love. Once they subscribe, you will get an additional 6 months of
                Family Central for free!</p>
            <p class="lp_p">Log in to start referring friends and family to earn your reward.</p>
            <div class="refer_login">
                <a routerLink="/login" class="primary_btn">Log In</a>
                <p class="sub_text mt-3">
                    Don’t have an account?
                    <a class="fw-700" routerLink="/signup-type">Sign up here</a>
                </p>
            </div>
        </div>
        <div class="lp_hero_image">
            <img class="w-100 d-none d-md-block" fetchpriority="high" src="/assets/images/refer/refer_hero.webp" alt="hero image" />
            <img class="w-100 d-block d-md-none" fetchpriority="high" src="/assets/images/refer/refer_hero-mbl.webp" alt="hero image" />
        </div>
    </div>
</div>

<div class="lp_features">
    <div class="px-90 m-auto text-center">
        <div class="how-it-works pt-5">
            <div class="features_top">
                <h2 class="lp_h2 mb-5">How it works</h2>
            </div>

            <div class="features_list d-grid">
                <div class="single_feature">
                    <div class="feature_img mb-3">
                        <img src="/assets/images/refer/refer_forward.svg" width="62" height="62" alt=""
                            loading="lazy" />
                    </div>
                    <p class="lp_p">Share the referral link with your friend</p>
                </div>
                <div class="single_feature">
                    <div class="feature_img mb-3">
                        <img src="/assets/images/refer/refer_user.svg" width="62" height="62" alt="" loading="lazy" />
                    </div>
                    <p class="lp_p">
                        Your friend signs up/places their first order for Family Central
                    </p>
                </div>
                <div class="single_feature">
                    <div class="feature_img mb-3">
                        <img src="/assets/images/refer/refer_gift.svg" alt="" width="62" height="62" loading="lazy" />
                    </div>
                    <p class="lp_p">You enjoy 6 months of Family Central FREE</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="get_started_section">
    <div class="get_started_content d-grid align-items-center">
        <div class="get_started_image">
            <img class="w-100" src="/assets/images/refer/refer_bottom.webp" alt="" loading="lazy" />
        </div>
        <div class="get_started_box">
            <h2 class="h2 mb-4">Ready To Get Started With Family Central?</h2>
            <form [formGroup]="emailForm">
                <div class="form-group get_started_field">
                    <input type="text" name="email" id="email" class="form-control"
                        placeholder="Enter your email address" formControlName="email" />
                    <button type="submit" class="primary_btn" (click)="goToOnboard()">
                        Sign up
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>